export default [
  {
    name: 'Фортум',
    logo: require('@/assets/partners/газпромбанк.png'),
    href: '#'
  },
  {
    name: 'ВТБ',
    logo: require('@/assets/partners/ингосстрах.png'),
    href: '#'
  },
  {
    name: 'Сбер',
    logo: require('@/assets/partners/05 некстепик.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/тим сторм.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/07 втб.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/10 экспомэп.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/07 иннохаб росатом.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/спектр.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/10 город зовет.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/07 росбанк.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/10 ол ивентс.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/где джоб.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/10 ивент хаб.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/10 иктугоу.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/02 проектная регата.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/01 глобал тек форум.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/10 воркспейс.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/02 ПиР.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/форейтинг.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/эсборд.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/00 тек уик.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/05 фаст лайф.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/Screenshot_60.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/эксмо.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/07 агророс банк.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/07 гнивц.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/06 мтс.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/ано ацр.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/Screenshot_61.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/гипросвязь.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/анкор.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/аспро клауд.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/06 технологии доверия.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/01 мердж.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/02 казань диджитал уик.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/00 продакт сенс.png'),
    href: '#'
  },
  {
    name: 'Дикси',
    logo: require('@/assets/partners/Screenshot_62.png'),
    href: '#'
  }
]
